import axios from "axios";
import BaseService from "./BaseService";
export default class AuthService extends BaseService {
    static async login(params = {}) {
        const res = await this.post(`/login`, params);
        return res.data;
    }
    static async getXsrfToken() {
        const domainCsrfToken = process.env.VUE_APP_API_CSRF_URL;
        const res = await axios.get(domainCsrfToken || "", { withCredentials: true });
        return res;
    }
    static async logout(params = {}) {
        const res = await this.post(`/logout`, params);
        return res.data;
    }
    static async getSsoConfig() {
        const res = await axios.get(`${this.getUrl("/auth/sso/config")}`);
        return res.data;
    }
    static async bootstrapSsoSession() {
        const res = await axios.get(`${this.getUrl("/auth/sso/bootstrap")}`, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                ...(typeof window !== "undefined" && window.location?.hostname
                    ? { "X-Social-Frontend-Host": window.location.hostname }
                    : {}),
            },
        });
        return res.data;
    }
    static async getSessionProfile() {
        const res = await this.get(`/profile`);
        return res.data;
    }
}
